const login_url = "/Users/Login";
const employee_details = "/DataSync/payroll/users/general-profile";
const employee_leave_balance = "/Employee/user-leave-balance";
const manager_leave_request = "/Employee/task-list";
const workflow_tasks_list = "/taskqueue/taskqueuelist";
const time_off = "/Employee/time-off";
const update_employee_leave_request = "/Employee/UpdateEmployeeRequest";
const approve_leave_request = "/Employee/approve-leave-request";
const get_managers_team = "/Employee/manager-team";
const get_tasks = "/Employee/getTasks";
const request_trail = "/taskqueue/audittrail";
const get_task_details = "/Employee/task-detail";
const update_profile_image = "/Users/profile-image";
const get_tasks_count = "/Employee/task-count";
const get_all_employee_association = "/Employee/all-employee-association";
const get_roles = "/Employee/GetRoles";
const search_associates = "/Employee/search-association";
const create_employee_association = "/Employee/employee-association";
const association_chart = "/Employee/association-tree";
const create_role = "/Users/CreateUserRole";
const update_user_status = "/Users/SetUserStatus";
const update_password = "/Users/ResetPassword";
const get_user_role_assignment = "/Users/GetUserRoleAssignment";
const post_user_role_assignment = "/Users/PostUserRoleAssignment";
const get_user_role_permissions = "/Users/GetUserRolePermission";
const post_role_permissions = "/Users/PostRolePermissions";
const get_time_entry = "/Employee/time-entry";
const delete_time_entry = "/Employee/time-entry";
const post_employee_time_record = "/Employee/post-employee-time-record";
const get_direct_deposits = "/DataSync/payroll/users/directdeposit";
const get_payroll_items = "/DataSync/payroll/users/payrollitem";
const get_payroll_item_details = "/Employee/payroll-item-detail";
const get_payroll_checks = "/DataSync/payroll-check";
const payroll_check_print = "/DataSync/payroll-check/print";
const get_payroll_check_details = "/Employee/payroll-check-detail";
const get_payroll_task = "/DataSync/payroll/users/hourtypes";
const post_employee_time_entry = "/Employee/time-entry";
const get_verify_payroll_user = "/DataSync/payroll/users/verify";
const post_link_employee = "/DataSync/payroll/users/link-employee";
const workflow_next_status_list = "/taskqueue/nextstatuslist";
const get_association_list = "/Employee/employee-association";
const get_cost_centers = "/DataSync/payroll/users/hourtypes";
const user_assignments = "/DataSync/payroll/users/user-assignment";
const time_entries_approval = "Employee/time-entries/submit";
const pay_cycles = "DataSync/payroll/users/paycycle";
const task_detail = "Employee/task-detail";
const pay_cycle_detail = "Employee/paycycle-detail";
const task_permission = "/bpm/task-permissions";
const task_call_off = "/bpm/task-calloff";
const invoke_workflow = "/bpm/invokeworkflow";
const assign_task = "/taskqueue/assign/task";
const user_groups = "/Users/usergroups";
const reverse_entry_status = "/Employee/reverse-entry-status";
const assignment_history = "DataSync/payroll/assignment-history";
const time_off_details = "Employee/time-off/details";
const user_permissions = "/Users/user-permissions";
const accruals = "/DataSync/payroll/accruals";
const sync_paycycles = "/DataSync/payroll/sync/all-paycycles";
const clock_in_out = "/Employee/clock-in-out";
const clock_out = "/Employee/clockouts";
const employee_accruals = "/Employee/accruals";
const transaction_details =
  "/DataSync/payroll/leave-balance/transaction-detail";
const get_published_w2 = "/DataSync/payroll/w2-information";
const get_published_w2_pdf = "/DataSync/payroll/w2-document";
const get_attributes = "/DataSync/attributes";
const get_dependents = "/DataSync/dependents";
const get_requests = "/ChangeRequest/paf-requests";
const paf_contact_information = "/ChangeRequest/paf-contact-information";
const paf_request_detail = "/ChangeRequest/paf-request-detail";

export {
  paf_request_detail,
  paf_contact_information,
  get_requests,
  get_dependents,
  get_attributes,
  get_published_w2_pdf,
  get_published_w2,
  transaction_details,
  employee_accruals,
  clock_out,
  clock_in_out,
  sync_paycycles,
  accruals,
  payroll_check_print,
  user_permissions,
  time_off_details,
  assignment_history,
  reverse_entry_status,
  assign_task,
  user_groups,
  invoke_workflow,
  task_call_off,
  task_permission,
  delete_time_entry,
  pay_cycle_detail,
  task_detail,
  login_url,
  employee_details,
  employee_leave_balance,
  time_off,
  update_employee_leave_request,
  approve_leave_request,
  manager_leave_request,
  get_managers_team,
  get_tasks,
  request_trail,
  get_task_details,
  update_profile_image,
  get_tasks_count,
  get_all_employee_association,
  get_roles,
  search_associates,
  create_employee_association,
  association_chart,
  create_role,
  update_user_status,
  update_password,
  get_user_role_assignment,
  post_user_role_assignment,
  get_user_role_permissions,
  post_role_permissions,
  get_time_entry,
  post_employee_time_record,
  workflow_tasks_list,
  get_direct_deposits,
  get_payroll_items,
  get_payroll_item_details,
  get_payroll_checks,
  get_payroll_check_details,
  get_payroll_task,
  post_employee_time_entry,
  get_verify_payroll_user,
  post_link_employee,
  workflow_next_status_list,
  get_association_list,
  get_cost_centers,
  user_assignments,
  time_entries_approval,
  pay_cycles
};
